import {Component, Input, OnInit} from '@angular/core';
import { UsuarioDtoResponse } from '../model/UsuarioDtoResponse';
import * as XLSX from 'xlsx';
import { IPerfilResponse } from '../model/interfaces-perfil';
import { Router } from '@angular/router';
import {IAtivarDesativarUsuario, IUsuarioArmazenamentoLocal, UsuarioSsoModel} from '../model/usuario-sso-model';
import {PerfisService} from "../perfis.service";

@Component({
  selector: 'app-gerenciar-usuarios-perfis',
  templateUrl: './gerenciar-usuarios-perfis.component.html',
  styleUrls: ['./gerenciar-usuarios-perfis.component.scss'],
})
export class GerenciarUsuariosPerfisComponent implements OnInit{
  @Input() usuariosDaEntidade!: Array<UsuarioDtoResponse>;
  @Input() lstperfis!: Array<IPerfilResponse>;

  usuario!: IUsuarioArmazenamentoLocal;
  public paginaAtual = 1;
  public usuariosDaEntidadeFiltrados!: Array<UsuarioDtoResponse>;

  _filtroUsuarios!: string;
  _routeState: any;
  _usuario: UsuarioDtoResponse = {} as UsuarioDtoResponse;
  tipoModificacao!: string;
  dscPerfilAntigo!: string;

  mensagens: string[] | [] = [];
  statusSucesso: string | 'alert-success' = 'alert-success';

  constructor(
    private router: Router,
    private service: PerfisService

  ) {
    this._routeState = this.router.getCurrentNavigation()?.extras.state;

    if (this._routeState) {
      this.usuariosDaEntidade = this._routeState.usuariosDaEntidade;
      this.lstperfis = this._routeState.lstperfis;
      this.usuariosDaEntidadeFiltrados = this.usuariosDaEntidade;
    } else this.router.navigate(['/perfis']).then(r => {console.log(r)});
  }

  ngOnInit(): void {
    this.getDadosUsuario();
  }

  getDadosUsuario() {
    try {
      this.service.getUsuarioLocalStorage().subscribe((r) => {
        this.usuario = r;
      });
    }catch {
      console.log('Erro ao buscar usuário');
  }
  }

  get filtroUsuarios(): string {
    return this._filtroUsuarios;
  }
  set filtroUsuarios(value: string) {
    this._filtroUsuarios = value;

    this.usuariosDaEntidadeFiltrados = this._filtroUsuarios
      ? this.filtrarUsuarios(this._filtroUsuarios)
      : this.usuariosDaEntidade;
  }

  filtrarUsuarios(filtroUsuarios: string): UsuarioDtoResponse[] {
    filtroUsuarios = filtroUsuarios.toLocaleLowerCase();

    return this.usuariosDaEntidade?.filter(
      (usuario: UsuarioDtoResponse) =>
        (usuario.dscNome &&
          usuario.dscNome.toLocaleLowerCase().indexOf(filtroUsuarios) !== -1) ||
        (usuario.dscEmail &&
          usuario.dscEmail.toLocaleLowerCase().indexOf(filtroUsuarios) !==
            -1) ||
        (usuario.dscLogin &&
          usuario.dscLogin.toLocaleLowerCase().indexOf(filtroUsuarios) !==
            -1) ||
        (usuario.dscStatus &&
          usuario.dscStatus.toLocaleLowerCase().indexOf(filtroUsuarios) !==
            -1) ||
        (usuario.dscTipoPerfil &&
          usuario.dscTipoPerfil.toLocaleLowerCase().indexOf(filtroUsuarios) !==
            -1) ||
        (usuario.dscIdentificacao &&
          usuario.dscIdentificacao
            .toLocaleLowerCase()
            .indexOf(filtroUsuarios) !== -1)
            
    );
  }




  setUsuario(usuario: UsuarioDtoResponse, tipoModificacao: string): void {
    this.tipoModificacao = tipoModificacao;
    this.dscPerfilAntigo = usuario.dscPerfil;
    this._usuario = usuario;

    let p = this.lstperfis.find(
      (perfil) => perfil.codperfil == usuario.codPerfil
    );

    this._usuario.dscPerfil = p?.dscperfil || '';
    this._usuario.codPerfil = p?.codperfil || 0;
  }

  private fecharModal(modal: string): void {
    document.getElementById(modal)?.click();
  }

  private  submeterUsuario(usuario: IAtivarDesativarUsuario): boolean{
    let result =  false;

    this.fecharModal('btnCancelarAlteracaoPerfil');
    this.service.ativarDesativarUsuario(usuario, this.usuario.guid)
      .subscribe((response) => {
        if(response.sucesso){
          this._usuario.dscStatus = this._usuario.dscStatus.toUpperCase() === 'ATIVO' ? 'INATIVO' : 'ATIVO';
          this.mensagens = ['Perfil do usuário alterado com sucesso!'];
          this.statusSucesso = 'alert-success';
          result =  true;
        }else{
          this.mensagens = response.mensagens;
          this.statusSucesso = 'alert-danger';
        }
      })

    return result;
  }

  private destacarDivAlterada(codAcesso: string): void {
    document.getElementById(codAcesso)?.classList.add('blink-div');
    setTimeout(() => {
      document.getElementById(codAcesso)?.classList.remove('blink-div');
    }, 3000)

  }

  modificarUsuario( ): void {

    console.log(this.tipoModificacao);

    if(this.tipoModificacao === 'modificar'){
      let ativarDesativar: IAtivarDesativarUsuario ={
        ativar: this._usuario.dscStatus.toUpperCase() === 'ATIVO',
        codLogin: this._usuario.codLogin,
        codEmpresa: this.usuario.codigoEntidade,
        codPerfil: this._usuario.codPerfil
      }
      if(this.submeterUsuario(ativarDesativar))
        this.fecharModal('btnCancelarAlteracaoPerfil');
    }

    if(this.tipoModificacao !== 'modificar'){
      let ativarDesativar: IAtivarDesativarUsuario ={
        ativar: this._usuario.dscStatus.toUpperCase() !== 'ATIVO',
        codLogin: this._usuario.codLogin,
        codEmpresa: this.usuario.codigoEntidade,
        codPerfil: this._usuario.codPerfil
      }
      if(this.submeterUsuario(ativarDesativar)){
        this._usuario.dscStatus = this._usuario.dscStatus.toUpperCase() === 'ATIVO' ? 'INATIVO' : 'ATIVO';
        this.fecharModal('btnCancelarAlteracaoPerfil');
      }
    }
    this.destacarDivAlterada(this._usuario.codAcesso);
  }
  exportUsuariosToExcel(tableId: string, fileName: string): void {
    if (this.usuariosDaEntidade.length > 0) {
      const workSheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
        this.usuariosDaEntidade
      );
      const workBook: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workBook, workSheet, tableId);
      XLSX.writeFile(workBook, `${fileName}.xlsx`);
    }
  }
}
